export default __webpack_public_path__ + "1871363981a7636bd314532c038208c8.svg";